<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'Investor Relations',
          to: {
            path: '/investor-relations',
            query: {
              section: $route.query.section,
            },
          },
        },
      ]"
    ></Breadscrumbs>
    <!-- page actions -->
    <div class="page-actions">
      <h2>Investor Relations</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span class="mr-2">編輯</span>
      </button>
    </div>
    <!-- block 1 -->
    <div class="block" style="margin-bottom: 30px;">
      <PageMenu :sections="sections">
        <component :is="sectionView" :ir="ir"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import PageMenu from '@/components/PageMenu.vue';

import PageTitle from '@/views/I_IR/c/I-0-1__IR-Page Title.vue';
import DefaultMessage from '@/views/I_IR/c/I-0-2__IR-Default messaging.vue';
import CorporateManagement from '@/views/I_IR/c/I-0-3__IR-Corporate Management.vue';
import FinancialInformation from '@/views/I_IR/c/I-0-4__IR-Financial Information.vue';
import Shareholder from '@/views/I_IR/c/I-0-5__IR-Shareholder.vue';

export default {
  components: {
    Breadscrumbs,
    PageMenu,
    PageTitle,
    DefaultMessage,
    CorporateManagement,
    FinancialInformation,
    Shareholder,
  },
  data: () => ({
    sections: [
      {
        name: 'Page Title',
        component: 'PageTitle',
      },
      {
        name: 'Default Message',
        component: 'DefaultMessage',
      },
      {
        name: 'Corporate Governance',
        component: 'CorporateManagement',
      },
      {
        name: 'Financial Information',
        component: 'FinancialInformation',
      },
      {
        name: 'Shareholder',
        component: 'Shareholder',
      },
    ],
  }),
  created() {
    this.getIrInfo();
  },
  computed: {
    ...mapState('ir', ['ir']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  methods: {
    ...mapActions('ir', {
      getIrInfo: 'find',
    }),
    editHandler() {
      this.$router.push({
        path: '/investor-relations/edit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>

<style></style>
